import PageWrapper from "@/components/atoms/PageWrapper";
import { NavigationBarBreadCrumbs } from '@/components/molecules/BackNav';
import { PageTitle } from "@/components/molecules/PageTitle";
import { Separator } from "@/components/ui/separator";
import { useProjectStore, useSurveyStore } from "@/lib/zustand/useStore";
import {
    Outlet,
    useLocation,
    useParams
} from "react-router-dom";

import { SurveyHeaderButtons } from "@/components/molecules/SurveyHeaderButtons";
import { setProjectContext } from "@/lib/utils/sentry/context/setProjectContext";
import { setSurveyContext } from "@/lib/utils/sentry/context/setSurveyContext";
import { useEffect } from "react";
import { useOrganizationStore } from '@/lib/zustand/useStore';

export default function RedirectToManageSurveyWithLayout() {
    /* 
    * Get the last segment of the URL to determine if the user is on the edit page or not
    */
    const location = useLocation();
    const segments = location.pathname.split('/');
    const lastSegmentOfURL = segments[segments.length - 1];

    const { project } = useProjectStore();
    const { survey } = useSurveyStore();

    /* 
    * Redirects the user to the correct survey or organization page based on the current URL.
    */
    const { orgId, projectId, surveyId } = useParams();
    // const navigate = useNavigate();
    // useEffect(() => {
    //     if (orgId && projectId && surveyId) {
    //         const rememberedOrgId = sessionStorage.getItem('orgId') || "external";
    //         sessionStorage.setItem('orgId', rememberedOrgId);
    //         navigate(generatePath('/organization/:orgId/project/:projectId/survey/:surveyId/manage-survey', {
    //             orgId: orgId,
    //             projectId: projectId,
    //             surveyId: surveyId
    //         }))
    //     }
    // }, [orgId, projectId, navigate, surveyId])

    /*
    * Handle Breadcrumbs current page name
    */
    // "edit", "members", "add-survey", "export", "questions", "manage-survey"
    const currentPageBreadCrumbsName = (lastSegmentOfURL: string) => {
        switch (lastSegmentOfURL) {
            case "edit":
                return "Edit";
            case "export":
                return "Export";
            case "questions":
                return "Questions";
            default:
                return "Information";
        }
    }
    useEffect(() => {
        setProjectContext(project);
        setSurveyContext(survey);

    }, [survey, project]);

    const { organization } = useOrganizationStore();

    return (
        <PageWrapper className="flex-col">
            <div className="flex flex-col flex-1 w-full gap-2 ">
                <NavigationBarBreadCrumbs.Set
                    currentPageName={currentPageBreadCrumbsName(lastSegmentOfURL)}
                    pages={[
                        {
                            title: "Home",
                            goTo: `/welcome`
                        },
                        {
                            title: `${organization?.name || "-"}`,
                            goTo: `/organization/${organization?.id}`
                        },
                        {
                            title: project?.name || "Project",
                            goTo: `/organization/${orgId}/project/${projectId}/manage-project`
                        },
                        {
                            title: survey?.name || "Survey",
                            goTo: `/organization/${orgId}/project/${projectId}/survey/${surveyId}/manage-survey`,
                        }
                    ]}
                />

                { lastSegmentOfURL !== 'questions' && (
                    <>
                        <div className="flex items-center justify-between">
                            <PageTitle
                                title="Survey"
                                description={survey?.name || ""}
                                isArchived={survey?.archived || false}
                                archivedIconDescription="Survey is archived"
                            />

                            <SurveyHeaderButtons />
                        </div>
                        <Separator />
                    </>
                )}

                <Outlet />
            </div >
        </PageWrapper >
    )
}